module.exports = __webpack_public_path__ + "img/slide10.0bcd219c.jpg";